import { JSX, SVGProps } from 'react';

export const Netlify = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    width={128}
    height={113}
    viewBox="0 0 128 113"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)" fill="#181A1C">
      <path d="M34.593 94.205h-1.209l-6.033-6.033v-1.208l9.223-9.223h6.39l.852.852v6.39zM27.351 25.97v-1.208l6.033-6.033h1.209l9.223 9.223v6.39l-.852.851h-6.39zM80.46 74.759h-8.778l-.733-.733V53.48c0-3.655-1.436-6.488-5.844-6.587-2.269-.06-4.865 0-7.638.108l-.416.426v26.59l-.733.732H47.54l-.733-.733V38.918l.733-.733h19.753c7.677 0 13.898 6.221 13.898 13.898v21.943zM35.841 61.603H.733L0 60.87v-8.796l.733-.734h35.108l.733.733v8.797zm91.436 0H92.169l-.733-.733v-8.796l.733-.734h35.108l.733.733v8.797zM58.943 27.219V.886l.733-.733h8.797l.733.733V27.22l-.733.732h-8.797zm0 84.837v-26.33l.733-.734h8.797l.733.733v26.331l-.733.734h-8.797z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 .154h128v112.635H0z" />
      </clipPath>
    </defs>
  </svg>
);
